import React from 'react';
import './ShimmerCard.css';

const ShimmerCard = () => {
  return (
    <div className="shimmer-card">
      <div className="shimmer-image"></div>
      <div className="shimmer-details">
        <div className="shimmer-line title"></div>
        <div className="shimmer-line text"></div>
        <div className="shimmer-line text short"></div>
        <div className="shimmer-footer">
            <div className="shimmer-line text"></div>
            <div className="shimmer-button"></div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerCard; 